import { RequiredPatternPasswordError } from '../errors/required-pattern-password-error';
export class RequiredPatternPasswordFieldValidation {
    constructor(field) {
        this.field = field;
    }
    validate(input) {
        return !input[this.field] ||
            String(input[this.field]).match(/^(?=.*[A-Z])(?=.*\d)(?=.*[-!@#$%^&*()_+~`|}{[\]\\:';"<>?,./])[A-Za-z\d\-!@#$%^&*()_+~`|}{[\]\\:';"<>?,./]+$/)
            ? null
            : new RequiredPatternPasswordError();
    }
}
